import { render, staticRenderFns } from "./CamstudyVideoControl.vue?vue&type=template&id=2a2f85ed&scoped=true&"
import script from "./CamstudyVideoControl.vue?vue&type=script&lang=js&"
export * from "./CamstudyVideoControl.vue?vue&type=script&lang=js&"
import style0 from "./CamstudyVideoControl.vue?vue&type=style&index=0&id=2a2f85ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f85ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2f85ed')) {
      api.createRecord('2a2f85ed', component.options)
    } else {
      api.reload('2a2f85ed', component.options)
    }
    module.hot.accept("./CamstudyVideoControl.vue?vue&type=template&id=2a2f85ed&scoped=true&", function () {
      api.rerender('2a2f85ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/CamstudyVideoControl.vue"
export default component.exports